import { useNavigate } from "react-router-dom";
import { Button, Typography } from "@firecms/ui";

type PanelAccessDeniedProps = {
  title?: string;
  message?: string;
  backLabel?: string;
  backHref?: string;
};

export function PanelAccessDenied({
  title = "Sin acceso",
  message = "No tenés permiso para administrar este recurso. Pedí acceso a un administrador de la cuenta.",
  backLabel,
  backHref,
}: PanelAccessDeniedProps) {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 p-8 text-center">
      <Typography variant="h4">{title}</Typography>
      <Typography variant="body1" className="max-w-md text-gray-600">
        {message}
      </Typography>
      {backLabel && backHref ? (
        <Button
          variant="filled"
          color="primary"
          onClick={() => navigate(backHref)}
        >
          {backLabel}
        </Button>
      ) : null}
    </div>
  );
}
